module.exports = __webpack_public_path__ + "img/illu_delete_mycontent.acc4e814.png";